const debounce = {
  inserted: function (el, binding) {
    let timer
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      if (!el.disabled) {
        el.disabled = true
        timer = setTimeout(() => {
          el.disabled = false
        }, binding.value || 1000)
      }
    })
  }
}

export default debounce



// WEBPACK FOOTER //
// ./src/directives/debounce.js